<template>
  <div v-title="$route.meta.title">
    <div class="page-heading header">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>付款管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel :collapse="false">
      <template slot="header">搜索</template>
      <el-form :model="search"
               :rules="searchRules"
               ref="searchForm"
               label-width="96px"
               label-position="right"
               size="medium"
               @submit.native.prevent="onSearch()">
        <div class="re-el-form__flex">
          <el-form-item label="申请人"
                        v-if="isSearchItemDisplay()"
                        prop="applicant">
            <remote-select
              class="width-max"
              clearable
              id-key="id"
              keyword-key="name"
              label-key="name"
              value-key="id"
              placeholder="请输入申请人名称，仅显示活跃状态的管理员"
              v-model="search.applicant"
              :query-request="(_)=>getPlatformUsersIndex(Object.assign(_, {usertype: [1,2,3,5], status: 1}))"
              :find-request="getPlatformUsersDetail">
            </remote-select>
          </el-form-item>
          <el-form-item label="部门"
                        prop="department_id">
            <remote-select
              class="width-max"
              clearable
              id-key="id"
              keyword-key="name"
              label-key="name"
              value-key="id"
              placeholder="请输入部门名称"
              v-model="search.department_id"
              :query-request="fetchDepartments"
              :find-request="getDepartmentDetail">
            </remote-select>
          </el-form-item>
          <el-form-item label="付款类型"
                        prop="type">
            <el-select v-model="search.type" clearable
                       multiple
                       class="width-max">
              <el-option v-for="(label, key) in {...type, 4: '批量付款'}"
                         :key="key"
                         :label="label"
                         :value="key">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="审批状态"
                        v-if="isSearchItemDisplay()"
                        prop="approve_status">
            <el-select v-model="search.approve_status"
                       class="width-max"
                       multiple
                       clearable>
              <el-option v-for="item in searchApproveStatus"
                         :key="item.key"
                         :label="item.label"
                         :value="item.key">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="付款状态"
                        v-if="isSearchItemDisplay()"
                        prop="payment_status">
            <el-select v-model="search.payment_status"
                       clearable
                       multiple
                       class="width-max">
              <el-option v-for="item in searchPaymentStatus"
                         :key="item.key"
                         :label="item.label"
                         :value="item.key">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="申请日期"
                        v-if="isSearchItemDisplay()"
                        prop="created_at">
            <el-date-picker
                v-model="search.created_at"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                align="center"
                class="width-max"
                :default-time="['00:00:00', '23:59:59']"
                clearable>
            </el-date-picker>
          </el-form-item>
          <el-form-item label="付款日期"
                        v-if="isSearchItemDisplay()"
                        prop="paid_date">
            <el-date-picker
                v-model="search.paid_date"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                align="center"
                class="width-max"
                :default-time="['00:00:00', '23:59:59']"
                clearable>
            </el-date-picker>
          </el-form-item>
          <el-form-item label="应付金额"
                        v-if="isSearchItemDisplay()">
            <el-col :span="11">
              <el-form-item prop='apply_amount_min'>
                <el-input v-model="search.apply_amount_min" placeholder="请输入应付金额起始值"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <p style="padding: 0; margin: 0; text-align: center">至</p>
            </el-col>
            <el-col :span="11">
              <el-form-item prop='apply_amount_max'>
                <el-input v-model="search.apply_amount_max" placeholder="请输入应付金额起始值"></el-input>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item label="是否加急"
                        prop="is_urgent">
            <el-select v-model="search.is_urgent" clearable
                       class="width-max">
              <el-option v-for="(label, key) in {1: '是', 0: '否'}"
                         :key="key"
                         :label="label"
                         :value="key">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="付款ID"
                        v-if="isSearchItemDisplay()"
                        prop="id">
            <el-input v-model="search.id" placeholder="请输入付款ID"></el-input>
          </el-form-item>

          <el-form-item label="冲销时间"
                        v-if="isSearchItemDisplay()"
                        prop="write_off_at">
            <el-date-picker
              v-model="search.write_off_at"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              align="center"
              class="width-max"
              :default-time="['00:00:00', '23:59:59']"
              clearable>
            </el-date-picker>
          </el-form-item>

          <el-form-item label="冲销状态"
                        v-if="isSearchItemDisplay()"
                        prop="write_off_status">
            <el-select v-model="search.write_off_status" clearable
                       multiple
                       class="width-max">
              <el-option v-for="(label, key) in writeOffStatus"
                         :key="key"
                         :label="label"
                         :value="key">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="付款公司"
                        prop="payment_company">
            <remote-select
              multiple
              class="width-max"
              clearable
              id-key="id"
              keyword-key="name"
              label-key="name"
              value-key="id"
              placeholder="仅支持搜索启用中的付款公司,可输入名称进行搜索"
              v-model="search.payment_company"
              :query-request="(_)=>fetchOurCompanies(Object.assign(_, {is_disabled: 0}))"
              :find-request="getOurCompaniesDetail">
            </remote-select>
          </el-form-item>

        </div>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     native-type="submit">搜索
          </el-button>
          <el-button @click="resetSearch()">重置
          </el-button>
        </el-form-item>
      </el-form>
    </layout-panel>
    <layout-panel>
      <template slot="header">列表</template>
      <template slot="tools">
        <el-button type="primary"
                   size="small"
                   icon="el-icon-refresh"
                   @click="onRefresh()"></el-button>
      </template>
      <div class="margin b15">
        <el-button type="primary"
                    icon="sj-icon-add"
                    @click="createPayment"
                    size="small">发起付款申请
        </el-button>
        <el-button type="primary"
                    icon="sj-icon-add"
                    @click="createBatchPayment"
                   size="small">人事批量付款申请
        </el-button>
        <el-button type="primary"
                    icon="sj-icon-export"
                    @click="onExportDetailSearch"
                   size="small">导出付款明细
        </el-button>
        <el-button type="primary"
                    icon="sj-icon-export"
                    @click="onExportWriteOffSearch"
                   size="small">导出预付款冲销明细
        </el-button>
        <el-button type="primary"
                   icon="sj-icon-export"
                   @click="onExportWriteOffStatus"
                   size="small">导出预付款冲销状态明细
        </el-button>
        <el-button type="primary"
                   @click="showSummaryVisible"
                   size="small">按搜索结果汇总
        </el-button>
        <el-button type="primary"
                    icon="sj-icon-pdf"
                    @click="onDownLoadPDFS"
                    :disabled="!multipleSelection.length"
                    size="small">批量生成PDF
        </el-button>

        <el-button type="success"
                   style="float:right;"
                   v-if="$route.meta.type !== 'approval'"
                   @click="redirectApproveTable"
                   size="small">查看待审批
        </el-button>
      </div>
      <el-table :data="table"
                stripe
                highlight-current-row
                border
                :cell-style="cellStyle"
                style="width: 100%"
                @selection-change="val => this.multipleSelection = val">
        <el-table-column
          type="selection"
          width="40">
        </el-table-column>
        <el-table-column label="ID" width="70">
          <template slot-scope="scope">
            <router-link :to="`/payment-manager/detail/${scope.row.id}`">
              <span size="mini">{{scope.row.id}}</span>
            </router-link>
          </template>
        </el-table-column>

        <template v-for="(attr, index) of fields">
          <el-table-column :key="index" v-bind="attr"></el-table-column>
        </template>
        <el-table-column fixed="right"
                         label="操作"
                         width="140">
          <template slot-scope="scope">
            <div class="button-gutter">
              <button-gutter>
                <router-link :to="`/payment-manager/detail/${scope.row.id}`">
                  <el-button size="mini" type="success">查看</el-button>
                </router-link>
                <router-link v-if="showCreateWriteOffButton(scope.row)" :to="`/payment-manager/write-off/create/${scope.row.id}`">
                  <el-button size="mini" type="warning">冲销-申请</el-button>
                </router-link>
                <router-link v-if="showUpdateWriteOffButton(scope.row)" :to="`/payment-manager/write-off/update/${scope.row.id}`">
                  <el-button size="mini" type="danger">冲销-修改</el-button>
                </router-link>
                <router-link v-if="showReviewWriteOffButton(scope.row)" :to="`/payment-manager/write-off/review/${scope.row.id}`">
                  <el-button size="mini" type="warning">冲销-审批</el-button>
                </router-link>
                <router-link v-if="checkReviewPermission(scope.row)" :to="`/payment-manager/review/${scope.row.id}?from=` + $route.meta.type">
                  <el-button size="mini"
                             type="warning">审批
                  </el-button>
                </router-link>
              </button-gutter>

              <button-gutter v-if="[13, 11].includes(scope.row.status) && scope.row.applicant * 1 === user.id * 1" style="margin-top: 10px;">
                <el-button size="mini"
                           @click="editPayment(scope.row)"
                           type="primary">修改
                </el-button>
                <el-button type="danger"
                           size="mini"
                           @click="abandonPaymentApplication(scope.row.id)">放弃
                </el-button>
              </button-gutter>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>
    <payment-summary-dialog
      title="付款汇总"
      :visible="summaryVisible"
      :data="paymentSummary"
      @closeDialog="summaryVisible = false"></payment-summary-dialog>
  </div>
</template>

<script>
import { searchRules } from '../payment-manager.rules.js'
import dateTimePicker from '@core/mixins/dateTimePicker'
import table, {removeEmptyParams} from '@core/mixins/table-v3'
import paymentManagerMixins from '../payment-manager.mixins'
import { checkReviewPermissionWithUser } from '../payment-manager-check-permission'
import paymentInfoExportMixins from '../payment-info-export.mixins'

import PaymentSummaryDialog from '@/views/payment-manager/components/PaymentSummaryDialog'

export default {
  components: {
    PaymentSummaryDialog,
  },
  mixins: [table, dateTimePicker, paymentManagerMixins, paymentInfoExportMixins],
  data () {
    return {
      searchRules,
      search: {
        applicant: null,
        type: [],
        department_id: null,
        payment_company: [],
        approve_status: [],
        payment_status: [],
        created_at: [],
        paid_date: [],
        write_off_at: [],
        write_off_status: [],
        apply_amount_min: null,
        apply_amount_max: null,
        is_urgent: null,
        id: null,
        is_from_todo_audit: false,
      },
      searchFieldType: {
        is_urgent: String,
        applicant: Number,
        department_id: Number,
      },
      multipleSelection: [],
      paymentCompanys: {},
      originFirstSubjects: {},
      originSecondSubjects: {},
      summaryVisible: false,
      paymentSummary: [],
    }
  },
  computed: Vuex.mapState({
    type: state => state.paymentManager.type,
    searchApproveStatus: state => state.paymentManager.searchApproveStatus,
    searchPaymentStatus: state => state.paymentManager.searchPaymentStatus,
    invoiceType: state => state.paymentManager.invoiceType,
    writeOffStatus: state => state.paymentManager.writeOffStatus,
    user: state => state.login.user,
  }),
  async created () {
    await this.getFinCenterConfigs()
  },
  methods: {
    ...Vuex.mapActions(['getPlatformUsersIndex', 'getPlatformUsersDetail']),
    ...request.map([]),
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData (params) {
      this.search.is_from_todo_audit = this.$route.meta.type === 'approval'
      params.is_from_todo_audit = this.search.is_from_todo_audit
      return request.page('getPaymentManagerTable', params)
    },
    exportTableData (params) {
      return request.page('exportTableData', params)
    },
    onExportRows (id) {
      this.$export(this.$route.meta.title, {
        type: 'array',
        request: (params) => request('exportPaymentManagerData', params),
        requestParams: {id},
        getResponseData (data) {
          // 导出大于一页时去掉标题行
          data.current_page > 1 && data.data.splice(0, 1)
          return data
        },
      })
    },
    getFinCenterConfigs () {
      return request.common('getFinCenterConfigs').then(({data}) => {
        this.setupSubjects(data)
        this.setupPaymentCompany(data)
      })
    },
    setupSubjects (data) {
      this.originFirstSubjects = this.expandData(_.values(data.first_subject_source))
      this.originSecondSubjects = this.expandData(_.values(data.second_subject_source))
    },
    setupPaymentCompany (data) {
      this.paymentCompanys = data.payment_apply_our_company_source.reduce((o, k) => {
        o[k.id] = k.name
        return o
      }, {})
    },
    expandData (data) {
      let result = {}
      for (const dataKey in data) {
        const tmp = data[dataKey]
        result[tmp.id] = tmp.name
      }
      return result
    },
    createPayment () {
      request.loading('getuserAccountDetailByUserID', {id: this.user.id}).then(({data}) => {
        if (data.length) {
          this.$router.push('/payment-manager/create')
        } else {
          throw Error('请联系人事或管理员将您更新至员工账户列表')
        }
      }).catch((_) => {
        this.$alert('请联系人事或管理员将您更新至员工账户列表', '提示', {type: 'warning'}).then(() => {
        })
      })
    },
    editPayment (row) {
      request.loading('getuserAccountDetailByUserID', {id: this.user.id}).then((res) => {
        let path = '/payment-manager/update/' + row.id
        if (row.type * 1 === 4) {
          path = '/payment-manager/batch-update/' + row.id
        }
        this.$router.push(path)
      }).catch((_) => {
        this.$alert('请联系人事或管理员将您更新至员工账户列表', '提示', {type: 'warning'}).then(() => {
        })
      })
    },
    createBatchPayment () {
      request.loading('getuserAccountDetailByUserID', {id: this.user.id}).then((res) => {
        this.$router.push('/payment-manager/bach-create')
      }).catch((_) => {
        this.$alert('请联系人事或管理员将您更新至员工账户列表', '提示', {type: 'warning'}).then(() => {
        })
      })
    },
    checkReviewPermission (row) {
      return checkReviewPermissionWithUser(row, this.user)
    },
    abandonPaymentApplication (id) {
      this.$confirm('确认放弃付款申请', '放弃付款申请', {type: 'warning'}).then(() => {
        request.common('abandonPaymentApplication', {id}).then((res) => {
          this.$message.success('已成功放弃')
          this.onRefresh()
        })
      })
    },
    fetchDepartments (name) {
      return request.common('getFinCenterDepartmentTableList', {query_all: true, ...name})
    },
    getDepartmentDetail (id) {
      return request.common('getFinCenterDepartmentDetail', id)
    },
    fetchOurCompanies (params) {
      return request.common('getFinCenterOurCompaniesTable', params)
    },
    getOurCompaniesDetail (id) {
      return request.common('getFinCenterOurCompaniesDetail', id).then(data => {
        data.data.id = String(data.data.id)
        return data
      })
    },
    cellStyle (row) {
      // 加急，且处于 待审批,财务审批,待付款,待修改 状态的条目,标红处理
      if (row.row.is_urgent && [1, 2, 3, 4, 5, 6, 7, 11, 13, 14].includes(row.row.status * 1)) {
        return 'color:red;font-weight:bold;'
      }
    },
    redirectApproveTable () {
      this.$router.push({path: '/payment-manager/approval'})
    },
    isSearchItemDisplay () {
      return this.$route.meta.type === 'table'
    },
    showSummaryVisible () {
      const fields = ['pending', '5', '6', '7', 'paid', 'other', 'summary']
      request.page('exportExportSearchAggregateData', removeEmptyParams(this.search)).then(({data}) => {
        data = {
          ...this.defalutValue,
          ...data
        }
        this.paymentSummary = fields.map(field => {
          return data[field]
        })
        this.summaryVisible = true
      })
    },
    inWriteoffStatus (row) {
      return row.type === 3 && [8, 10].includes(row.status) && [1, 2].includes(row.write_off_status)
    },
    showCreateWriteOffButton (row) {
      // 超管 或 财务管理员 或 单子发起人
      const canCreateUser = this.user.usertype === '1' || this.user.usertype === '5' || this.user.id * 1 === row.applicant
      if (canCreateUser && row.wait_write_off > 0 && this.inWriteoffStatus(row)) {
        // 第一次 添加 冲销
        if (!row.write_off_states || !row.write_off_states.length) {
          return true
        }
        // 第N次 添加 冲销
        if (row.write_off_states.length === 1 && row.write_off_states[0] === 8) {
          return true
        }
      }
      return false
    },
    showUpdateWriteOffButton (row) {
      // 超管 或 财务管理员 或 单子发起人
      const canEditUser = this.user.usertype === '1' || this.user.usertype === '5' || this.user.id * 1 === row.applicant
      return canEditUser && row.write_off_states.includes(9) && this.inWriteoffStatus(row)
    },
    showReviewWriteOffButton (row) {
      return (this.user.usertype === '1' || row.current_approver === this.user.id * 1) && row.write_off_states.some(item => [1, 2, 3, 4, 5].includes(item)) && this.inWriteoffStatus(row)
    },
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
.header {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/payment-manager/pages/PaymentManagerTable.vue